export enum CampoEnum {
  "Endereço" = 8,
  "Dados da Mãe" = 9,
  "Dados do Pai" = 10,
  "Dados do Contato" = 11,
  "Dados do Convite" = 12,
  // Parente = 14,
  "Congregação" = 15,
  // Diocese = 25,
  // Cargo = 24,
  Alergia = 16,
  "Medicação" = 17,
  "Restrição Alimentar" = 18,
  "Cônjuge" = 19,
  Camisa = 20,
  "Convênio" = 21,
  Casamento = 23,
}
